import React, { useCallback, useEffect, useState } from 'react';
import api from '../../api/axios';

function MicrosoftBookingsControls({ campaignId, config, onChange }) {
  const [status, setStatus] = useState(null);
  const [businesses, setBusinesses] = useState([]);
  const [services, setServices] = useState([]);
  const [businessId, setBusinessId] = useState(config.externalAccountId || '');
  const [serviceId, setServiceId] = useState(config.externalServiceId || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const response = await api.get('/agent/meeting-integrations/microsoft/status');
      setStatus(response.data);
      if (response.data.bookingsPermission) {
        const businessesResponse = await api.get('/agent/meeting-integrations/microsoft/businesses');
        setBusinesses(businessesResponse.data.businesses || []);
      }
      setError('');
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data?.error || err.message);
    }
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { setBusinessId(config.externalAccountId || ''); setServiceId(config.externalServiceId || ''); }, [config.externalAccountId, config.externalServiceId]);

  useEffect(() => {
    if (!businessId || !status?.bookingsPermission) { setServices([]); return; }
    api.get('/agent/meeting-integrations/microsoft/services', { params: { businessId } })
      .then((response) => setServices(response.data.services || []))
      .catch((err) => setError(err.response?.data?.message || err.message));
  }, [businessId, status?.bookingsPermission]);

  const grantAccess = async () => {
    setBusy(true); setError('');
    try {
      const response = await api.post('/agent/meeting-integrations/microsoft/start', { returnPath: `/campaigns/${campaignId}/agent` });
      window.location.assign(response.data.url);
    } catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); setBusy(false); }
  };

  const saveSelection = async () => {
    const business = businesses.find((item) => item.id === businessId);
    const bookingUrl = config.bookingUrl || business?.publicUrl || '';
    if (!businessId || !serviceId || !bookingUrl) { setError('Kies een Bookings-bedrijf en dienst en vul een geldige openbare Bookings-link in.'); return; }
    setBusy(true); setError('');
    try {
      const response = await api.patch(`/agent/campaigns/${campaignId}/microsoft-bookings`, { businessId, serviceId, bookingUrl });
      onChange({ ...config, ...response.data.config });
    } catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); }
    finally { setBusy(false); }
  };

  const syncNow = async () => {
    setBusy(true); setError('');
    try { await api.post(`/agent/campaigns/${campaignId}/microsoft-bookings/sync`); }
    catch (err) { setError(err.response?.data?.message || err.response?.data?.error || err.message); }
    finally { setBusy(false); }
  };

  return <div className="meeting-provider-native-panel">
    <div className="meeting-provider-native-head">
      <div><strong>Microsoft Bookings</strong><p>Gebruikt hetzelfde Microsoft-account als e-mail, met alleen extra leesrechten voor Bookings.</p></div>
      {!status?.bookingsPermission
        ? <button className="campaign-agent-button secondary" disabled={busy} onClick={grantAccess}>{busy ? 'Doorsturen…' : status?.connected ? 'Bookings-toegang verlenen' : 'Microsoft koppelen'}</button>
        : <span className="calendly-connected-badge">Bookings actief</span>}
    </div>
    {error && <div className="planner-warning">{error}</div>}
    {status?.bookingsPermission && <div className="meeting-provider-native-grid">
      <label>Bookings-bedrijf<select value={businessId} onChange={(e) => { setBusinessId(e.target.value); setServiceId(''); }}><option value="">Kies bedrijf</option>{businesses.map((item) => <option key={item.id} value={item.id}>{item.displayName}</option>)}</select></label>
      <label>Dienst<select value={serviceId} onChange={(e) => setServiceId(e.target.value)} disabled={!businessId}><option value="">Kies dienst</option>{services.map((item) => <option key={item.id} value={item.id}>{item.displayName}</option>)}</select></label>
      <div className="meeting-provider-native-actions"><button className="campaign-agent-button secondary" disabled={busy || !businessId || !serviceId} onClick={saveSelection}>Gebruik voor campagne</button>{config.provider === 'microsoft_bookings' && config.externalAccountId && <button className="campaign-agent-button secondary" disabled={busy} onClick={syncNow}>Nu synchroniseren</button>}</div>
    </div>}
  </div>;
}

export default MicrosoftBookingsControls;
